import { render, staticRenderFns } from "./ReleasesNotes.vue?vue&type=template&id=2a94f7f3&scoped=true&"
import script from "./ReleasesNotes.vue?vue&type=script&lang=js&"
export * from "./ReleasesNotes.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesNotes.vue?vue&type=style&index=0&id=2a94f7f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a94f7f3",
  null
  
)

export default component.exports